<template>
  <div
    id="page-print"
  >
    <b-navbar
      toggleable="lg"
      variant="white"
    >
      <b-navbar-brand href="#">
        <a
          href="/"
        >
          <logo-icon
            id="LogoIcon"
            class="logo"
          />
        </a>
      </b-navbar-brand>

      <b-navbar-nav class="ml-auto align-items-center">

        <div
          v-if="showPatientControls"
          class="d-flex align-items-center mr-75"
        >
          <b-form-select
            v-model="patientModeSelection"
            :options="modeSelectOptions"
            size="sm"
          />
        </div>

        <div>
          <b-button
            class="my-2 my-sm-0"
            variant="flat-primary"
            @click="print()"
          >
            <feather-icon
              icon="PrinterIcon"
              size="24"
            />
          </b-button>

          <b-button
            class="my-2 my-sm-0"
            variant="flat-secondary"
            @click="$router.back()"
          >
            <feather-icon
              icon="XIcon"
              size="24"
            />
          </b-button>
        </div>

      </b-navbar-nav>

    </b-navbar>

    <router-view @print-ready="handlePrintReady" />

  </div>
</template>

<script>

import {
  BButton,
  BFormSelect,
  BNavbar,
  BNavbarBrand,
  BNavbarNav,
} from 'bootstrap-vue'
import LogoIcon from '@core-override/layouts/components/LogoIcon.vue'

export default {
  components: {
    LogoIcon,
    BNavbar,
    BNavbarBrand,
    BNavbarNav,
    BButton,
    BFormSelect,
  },
  data() {
    return {
      printSettings: {
        mode: 'single',
        selectedPatientIndex: 0,
      },
      modeInitialized: false,
      lastOrderId: null,
      autoPrintTriggered: false,
    }
  },
  provide() {
    return {
      printSettings: this.printSettings,
    }
  },
  computed: {
    order() {
      return this.$store.getters['order/getOrderData']
    },
    patients() {
      return this.order && Array.isArray(this.order.patientInfo) ? this.order.patientInfo : []
    },
    showPatientControls() {
      return this.$route.name === 'order-order' && this.patients.length > 1
    },
    modeSelectOptions() {
      if (!this.patients.length) {
        return []
      }
      return [
        // {
        //   value: 'all',
        //   text: this.$t('print.mode.all'),
        // },
        ...this.patientOptions,
      ]
    },
    patientOptions() {
      return this.patients.map((patient, index) => {
        const labelParts = []
        if (patient && patient.surname) {
          labelParts.push(patient.surname)
        }
        if (patient && patient.name) {
          labelParts.push(patient.name)
        }
        const fallbackLabel = this.$t('order.patient-info.single-title', {
          index: index + 1,
        })
        return {
          value: index,
          text: labelParts.length ? labelParts.join(' ') : fallbackLabel,
        }
      })
    },
    patientModeSelection: {
      get() {
        if (this.printSettings.mode === 'all') {
          return 'all'
        }
        return this.printSettings.selectedPatientIndex
      },
      set(value) {
        if (value === 'all') {
          this.printSettings.mode = 'all'
          this.printSettings.selectedPatientIndex = 0
          return
        }
        const patientIndex = Number(value)
        this.printSettings.mode = 'single'
        this.printSettings.selectedPatientIndex = Number.isNaN(patientIndex) ? 0 : patientIndex
      },
    },
  },
  watch: {
    patients: {
      immediate: true,
      handler(newPatients) {
        if (!newPatients || !newPatients.length) {
          this.modeInitialized = false
          this.printSettings.mode = 'single'
          this.printSettings.selectedPatientIndex = 0
          return
        }

        if (!this.modeInitialized) {
          // this.printSettings.mode = newPatients.length > 1 ? 'all' : 'single'
          this.printSettings.mode = 'single'
          this.modeInitialized = true
        }

        if (this.printSettings.selectedPatientIndex > newPatients.length - 1) {
          this.printSettings.selectedPatientIndex = 0
        }
      },
    },
    'printSettings.mode': function printSettingsModeWatcher(newMode, oldMode) {
      if (newMode === 'all') {
        this.printSettings.selectedPatientIndex = 0
        return
      }
      if (oldMode === 'all' && this.patients.length) {
        this.printSettings.selectedPatientIndex = 0
      }
    },
    'order.id': {
      immediate: true,
      handler(newId) {
        if (this.lastOrderId === newId) {
          return
        }
        this.lastOrderId = newId
        this.modeInitialized = false
        this.printSettings.selectedPatientIndex = 0
      },
    },
  },
  methods: {
    print() {
      window.print()
    },
    handlePrintReady() {
      if (this.$route.query.autoPrint !== '1' || this.autoPrintTriggered) {
        return
      }

      this.autoPrintTriggered = true
      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => this.print())
        })
      })
    },
  },
}
</script>

<style lang="scss">
small {
  font-size: 8pt;
}

.logo {
  margin-top: 5px;
  height: 48px;
}

@page {
  size: A4;
  margin: 0;
}

@media print {
  html, body {
    width: 210mm;
    height: 297mm;
  }
}
</style>
